import { EMPLOYMENT_TYPES } from 'cpool-constants';
import type { Schema_Beschaeftigung } from 'cpool-schemas';

const getDefaultStudent = (): {
    beschaeftigung: Extract<Schema_Beschaeftigung, { beschaeftigungsart: typeof EMPLOYMENT_TYPES.STUDENT }>;
} => ({
    beschaeftigung: {
        beschaeftigungsart: EMPLOYMENT_TYPES.STUDENT,
        steuerklasse: null,
        student: {
            sonstigesEinkommenMonatlich: null,
        },
    },
});
export default getDefaultStudent;
